import React from 'react';
import { useTranslation } from 'react-i18next';

const ErrorMessage = ({ error }) => {
  const { t } = useTranslation();
  const errorMessage = error?.message || error?.toString() || t('common.errorOccurred');
  
  return (
    <div className="container-fluid py-1">
      <div className="alert alert-danger" role="alert">
        <h4 className="alert-heading">{t('common.error')}</h4>
        <p className="mb-0">{errorMessage}</p>
      </div>
    </div>
  );
};

export default ErrorMessage;
